import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTransition, animated } from 'react-spring'
import loadjs from 'loadjs'
import { ButtonA, Button } from '../components/button'
import dlv from 'dlv'
import dset from 'dset'
import { TrailEls } from '../helpers'

import WhyLongContent from './why-long-content'

import { WhyForm } from '../forms.js'

const smokeImage =
	'https://res.cloudinary.com/boostcreative/image/upload/v1556802904/smoke_qb1sli.png'

const StopWatchIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293.1 384.1">
		<path
			fill="#0a4b6c"
			d="M156 91.3V80h-18.8v11.3a146.6 146.6 0 1 0 18.8 0zM146.5 365A127.5 127.5 0 1 1 274 237.5 127.5 127.5 0 0 1 146.6 365zm0-249.5a122 122 0 1 0 122 122 122.2 122.2 0 0 0-122-122zm0 237.1a115.1 115.1 0 1 1 115-115 115.2 115.2 0 0 1-115 115zM195.4 148l2.5-4.3a2.5 2.5 0 0 1 4.3 2.5l-2.4 4.3a2.5 2.5 0 0 1-4.4-2.5zm-52.3-5.5v-11.9a3.5 3.5 0 0 1 7 0v12a3.5 3.5 0 0 1-7 0zm-91.4 40.4a2.5 2.5 0 0 1 3.5-1l4.3 2.5a2.5 2.5 0 1 1-2.5 4.4l-4.3-2.5a2.5 2.5 0 0 1-1-3.4zM91 146a2.5 2.5 0 1 1 4.3-2.5l2.5 4.3a2.5 2.5 0 0 1-.9 3.4 2.4 2.4 0 0 1-1.2.3 2.5 2.5 0 0 1-2.2-1.2zM60.4 287.3a2.5 2.5 0 0 1-1 3.4l-4.2 2.5a2.4 2.4 0 0 1-1.3.3 2.5 2.5 0 0 1-1.2-4.7l4.2-2.4a2.5 2.5 0 0 1 3.5.9zm-9-46.3H39.7a3.5 3.5 0 1 1 0-7h11.9a3.5 3.5 0 0 1 0 7zm46.3 86.1l-2.5 4.3A2.5 2.5 0 0 1 91 329l2.5-4.3a2.5 2.5 0 1 1 4.3 2.5zm135-139.4a2.5 2.5 0 0 1 1-3.4l4.3-2.4a2.5 2.5 0 1 1 2.5 4.3l-4.3 2.5a2.4 2.4 0 0 1-1.3.3 2.5 2.5 0 0 1-2.1-1.3zm8.7 104.6a2.5 2.5 0 0 1-2.2 1.2 2.6 2.6 0 0 1-1.2-.3l-4.3-2.5a2.5 2.5 0 1 1 2.5-4.3l4.3 2.4a2.5 2.5 0 0 1 .9 3.4zm15.6-54.8a3.5 3.5 0 0 1-3.5 3.5h-11.8a3.5 3.5 0 0 1 0-7h11.8a3.5 3.5 0 0 1 3.5 3.5zm-107 95.1v11.9a3.5 3.5 0 0 1-7 0v-11.9a3.5 3.5 0 0 1 7 0zm52.2-3.7a2.5 2.5 0 0 1-.9 3.4 2.4 2.4 0 0 1-1.3.4 2.5 2.5 0 0 1-2.1-1.3l-2.5-4.3a2.5 2.5 0 1 1 4.3-2.5zm-55.6-105.1a13.7 13.7 0 0 0-12 20.5l-17.2 19 9.2 7.7 15.6-20.5a13.7 13.7 0 0 0 15.7-20.7l53.8-71-59.6 66.1a13.6 13.6 0 0 0-5.5-1.1zm0 20.6a6.9 6.9 0 1 1 6.8-6.9 6.9 6.9 0 0 1-6.8 6.9zM34.5 108.8a5 5 0 0 1 1-7l16.9-12.5a5 5 0 0 1 7 1l4.5 6.3a5 5 0 0 1-1 7l-.9.6 3.8 4.3-15 11.2-3.9-4.3-.9.6a5 5 0 0 1-6.9-1zm192.8-.3l3.8-4.3-.9-.7a5 5 0 0 1-1-7l4.6-6.1a5 5 0 0 1 7-1l16.8 12.4a5 5 0 0 1 1 7L254 115a5 5 0 0 1-7 1l-.8-.6-3.8 4.2zM124.3 63v2.5a9 9 0 0 0 9 9h26.6a9 9 0 0 0 9-9V63a22.8 22.8 0 0 0 16-21.8V22.8A22.8 22.8 0 0 0 162 0h-31a22.8 22.8 0 0 0-22.9 22.8v18.4a22.8 22.8 0 0 0 16 21.8zM115 22.8a16 16 0 0 1 16-16h31a16 16 0 0 1 16 16v18.4a16 16 0 0 1-9.1 14.5v-4.2a9 9 0 0 0-9-9h-26.7a9 9 0 0 0-9 9v4.2a16 16 0 0 1-9.1-14.5V22.8z"
		/>
	</svg>
)

function createSmoke() {
	let camera,
		scene,
		renderer,
		geometry,
		material,
		mesh,
		clock,
		cubeSineDriver,
		light,
		smokeTexture,
		smokeMaterial,
		smokeGeo,
		smokeParticles,
		delta
	let { THREE } = window

	init()
	animate()

	function init() {
		clock = new THREE.Clock()

		renderer = new THREE.WebGLRenderer({ alpha: true })
		renderer.setSize(window.innerWidth, window.innerHeight)

		scene = window.renderScene = new THREE.Scene()

		camera = new THREE.PerspectiveCamera(
			75,
			window.innerWidth / window.innerHeight,
			1,
			10000
		)
		camera.position.z = 1000
		scene.add(camera)

		geometry = new THREE.BoxGeometry(200, 200, 200)
		material = new THREE.MeshLambertMaterial({
			color: 0xaa6666,
			wireframe: false,
		})
		mesh = new THREE.Mesh(geometry, material)
		//scene.add( mesh );
		cubeSineDriver = 0

		THREE.ImageUtils.crossOrigin = '' //Need this to pull in crossdomain images from AWS

		light = new THREE.DirectionalLight(0xffffff, 0.5)
		light.position.set(-1, 0, 1)
		scene.add(light)

		smokeTexture = new THREE.TextureLoader().load(smokeImage)
		smokeMaterial = new THREE.MeshLambertMaterial({
			color: 0xffffff,
			map: smokeTexture,
			transparent: true,
		})
		smokeGeo = new THREE.PlaneBufferGeometry(330, 330)
		smokeParticles = []

		for (let p = 0; p < 50; p++) {
			var particle = new THREE.Mesh(smokeGeo, smokeMaterial)
			particle.position.set(
				Math.random() * 600 - 250,
				Math.random() * 500 - 250,
				Math.random() * 1000 - 100
			)
			particle.rotation.z = Math.random() * 360
			scene.add(particle)
			smokeParticles.push(particle)
		}

		let container = document.getElementById('why_view_three')
		if (!!container) {
			container.querySelector('.ps-main').appendChild(renderer.domElement)
		} else {
			destroySmoke()
		}
	}

	function animate() {
		// note: three.js includes requestAnimationFrame shim
		delta = clock.getDelta()
		requestAnimationFrame(animate)
		evolveSmoke()
		render()
	}

	function evolveSmoke() {
		var sp = smokeParticles.length
		while (sp--) {
			smokeParticles[sp].rotation.z += delta * 0.2
		}
	}

	function render() {
		mesh.rotation.x += 0.005
		mesh.rotation.y += 0.01
		cubeSineDriver += 0.01
		mesh.position.z = 100 + Math.sin(cubeSineDriver) * 500
		renderer.render(scene, camera)
	}
}

function destroySmoke() {
	let scene = window.renderScene
	if (scene) {
		for (let i = scene.children.length - 1; i >= 0; i--) {
			const object = scene.children[i]
			if (object.type === 'Mesh') {
				object.geometry.dispose()
				object.material.dispose()
				scene.remove(object)
			}
		}
	}
}

const WhyPage = ({
	setDropletState,
	scrollbarWidth,
	ourFormData,
	setOurFormData,
	animateTransitions,
}) => {
	// const [answerVal, setAnswerVal] = useState()
	// const [continued, setContinued] = useState()
	const [madeSmoke, setMadeSmoke] = useState()
	// const [expandedContent, setExpandContent] = useState()

	const answerVal = dlv(ourFormData, 'why.answer')

	const continued = dlv(ourFormData, 'why.continued')
	const setContinued = state => {
		// clone our form data
		let newFormData = JSON.parse(JSON.stringify(ourFormData))
		// update w/ answer
		dset(newFormData, 'why.continued', state)
		setOurFormData(newFormData)
	}

	useEffect(() => {
		// update droplets
		if (!continued) {
			setDropletState([1, 0, 0, 0, 0])
		} else {
			setDropletState([1, 0.5, 0, 0, 0])
		}
		// add smoke
		if (continued && !madeSmoke) {
			setMadeSmoke(true)
			setTimeout(() => {
				loadjs(
					[
						'https://cdn.jsdelivr.net/npm/three@0.103.0/build/three.min.js',
						smokeImage,
					],
					createSmoke
				)
			}, 800)
		}
		return () => {
			destroySmoke()
		}
	}, [continued])

	const initialViewTransition = useTransition(!answerVal, null, {
		initial: { opacity: 1, transform: `scale(1)` },
		leave: { opacity: 0, transform: `scale(0.9)` },
	})
	const secondViewTransition = useTransition(answerVal && !continued, null, {
		from: { opacity: 0, transform: `scale(1.1)` },
		enter: { opacity: 1, transform: `scale(1)` },
		leave: { opacity: 0, transform: `scale(0.9)` },
	})
	const thirdViewTransition = useTransition(continued, null, {
		from: { opacity: 0, transform: `scale(1.1)` },
		enter: { opacity: 1, transform: `scale(1)` },
	})

	const responseData = {
		Yes: {
			heading: 'Great News!',
			content: (
				<p>
					Because you live in a sprinklered home, your family is protected. What
					you saw in that commercial <br /> won’t happen to you.
				</p>
			),
			leadContent: (
				<p>
					Continue reading to learn why fire sprinklers are so <br /> vital to
					your family’s safety.
				</p>
			),
		},
		No: {
			heading: 'Oh no!',
			content: (
				<p>
					The vast majority of fire deaths in the US
					<br /> happen in homes.
				</p>
			),
			leadContent: (
				<p>
					Learn why and how you can protect your family
					<br /> with fire sprinklers by continuing on.
				</p>
			),
		},
	}

	return (
		<div className={`page page-why`}>
			{initialViewTransition.map(
				({ item, key, props }) =>
					item && (
						<animated.div key={key} style={props} className="page-sections">
							<div className="main ps-main">
								<div className="inner-wrap">
									<TrailEls
										animateTransitions={animateTransitions}
										items={[
											<div className="section-header">
												<h2 className="section-heading">
													Why do you need <strong>fire sprinklers?</strong>
												</h2>
												<p>(Start by answering the question below)</p>
											</div>,
											<div className="gradient-wrap">
												<div className="gw-inner">
													<WhyForm
														answerVal={answerVal}
														ourFormData={ourFormData}
														setOurFormData={setOurFormData}
													/>
												</div>
											</div>,
										]}
									/>
								</div>
							</div>
							<div className="main ps-footer">
								<div className="inner-wrap">
									<div className="section-footer">
										<p>
											Receive more information on installing fire sprinklers...
										</p>
										<Link to="/full-form" className="def-link">
											Skip to the contact form
										</Link>
									</div>
								</div>
							</div>
						</animated.div>
					)
			)}
			{secondViewTransition.map(({ item, key, props }) => {
				if (item) {
					const { heading, content, leadContent } = responseData[answerVal]
					return (
						<animated.div
							key={key}
							style={props}
							className="page-sections view-two"
						>
							<div className="main ps-main">
								<div className="inner-wrap">
									<TrailEls
										animateTransitions={animateTransitions}
										items={[
											<div className="section-header">
												<h2 className="section-heading">
													Why do you need <strong>fire sprinklers?</strong>
												</h2>
											</div>,

											<div className="gradient-wrap">
												<div className="gw-inner second">
													<h3>{heading && heading}</h3>
													<div className="answer-exp">{content && content}</div>
													{leadContent && leadContent}
													<Button
														className="btn btn-white"
														onClick={() => setContinued(true)}
													>
														Continue ››
													</Button>
												</div>
											</div>,
										]}
									/>
								</div>
							</div>
							<div className="main ps-footer">
								<div className="inner-wrap">
									<div className="section-footer">
										<p>
											Receive more information on installing fire sprinklers...
										</p>
										<Link to="/full-form" className="def-link">
											Skip to the contact form
										</Link>
									</div>
								</div>
							</div>
						</animated.div>
					)
				} else {
					return null
				}
			})}
			{thirdViewTransition.map(
				({ item, key, props }) =>
					item && (
						<React.Fragment key={key}>
							<animated.div
								style={props}
								className={`page-sections view-three`}
								id="why_view_three"
							>
								<div className="main ps-main">
									<div className="inner-wrap">
										<TrailEls
											animateTransitions={animateTransitions}
											items={[
												<div className="section-header">
													<h2 className="section-heading">
														Why do you need <strong>fire sprinklers?</strong>
													</h2>
												</div>,
												<div className="stopwatch svg-wrap">
													<StopWatchIcon />
												</div>,
												<div className="view-three-content">
													<h2>You have less than 5 minutes to get out!</h2>
													<p>
														That’s all the time you may have before a deadly
														phenomenon called flashover happens, <br /> and
														smoke alone causes most deaths. Sprinklered homes
														have 81% fewer deaths <br /> and suffer 58% less
														damage. They buy your family time to escape safely.
													</p>
													<ButtonA href="#learn_more" className="btn">
														Learn More
													</ButtonA>
												</div>,
											]}
										/>
									</div>
								</div>
								<div id="learn_more">
									<WhyLongContent />
								</div>
							</animated.div>
							<Link
								to="/how"
								className="next-link"
								style={{ right: scrollbarWidth }}
							>
								Next
							</Link>
						</React.Fragment>
					)
			)}
		</div>
	)
}

export default WhyPage
